<div id="isHome"></div>
<div class="home">
    <div class="banner-cell">
        <div class="row">
            <div class="col-md-12">
                <img src="assets/images/logo.png" width="200px" alt="About Main Image">
            </div>
        </div>
        <div class="row lg">
            <div class="col-md-12 typer">
                <!-- <h1>Pas comme les autres...
                    <span class="cursor" data-cursordisplay="_" data-owner="some-id"
                        style="transition: all 0.1s ease 0s; opacity: 1;">
                        _
                    </span>
                </h1> -->
                <div class="book-btn">
                    <a class="btn btn-order" routerLink="/carte">
                        <img src="assets/images/add.png" alt="commander">
                        <span>commander en ligne</span>
                    </a>
                </div>
                <div class="gradient-border" id="box" *ngIf="enablePayement">
                    <img src="assets/images/payamenet2.png" alt="Paiement par carte bancaire">
                </div>
            </div>
        </div>

    </div>
</div>
<div id="about" class="about pad-top-100 pad-bottom-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="wow fadeIn" data-wow-duration="1s" data-wow-delay="0.1s"
                    style="visibility: visible; animation-duration: 1s; animation-delay: 0.1s; animation-name: fadeIn;">
                    <h2 class="block-title">À propos de nous</h2>
                    <div *ngIf="pdv?.comment" [innerHtml]="pdv?.comment" class="comment"></div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <div class="wow fadeIn" data-wow-duration="1s" data-wow-delay="0.1s"
                    style="visibility: visible; animation-duration: 1s; animation-delay: 0.1s; animation-name: fadeIn;">
                    <div class="about-images">
                        <img class="about-main" src="assets/images/about-main.jpg" alt="About Main Image">
                        <img class="about-inset" src="assets/images/about-inset.jpg" alt="About Inset Image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="offer-sec">
    <div class="container offers">
        <h1>Nos meilleurs offres</h1><br /><br />
        <h2>Commandez... C'est livré</h2>
        <br />
        <a routerLink="/carte" class="btn btn-danger">Découvrez nos meilleures offres</a>
        <br />
    </div>
</div>
<div class="our-products">
    <h1 class="text-center title">
        Nos Produits
    </h1>
    <div>
        <products></products>
    </div>
</div>
<mobile></mobile>